import React, { Component } from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

import Card from "@mui/material/Card";
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

import Box from "@mui/material/Box";


import { CardContent, CircularProgress, Dialog, IconButton, Paper } from "@mui/material";
import { getURLBase, updateHeightAfterContentUpdate, updateParentHeight } from "../../../utils/helperFns";
import axios from "axios";

import Divider from '@mui/material/Divider';
import TotalBalanceTransactionItem from "../../../widgets/TotalBalanceTransactionItem";
import { ArrowBack } from "@mui/icons-material";


import moneyhubLogo from "../../../images/moneyhub logo.png";
import { Stack, Button } from '@mui/material';
import DialogTitle from '@mui/material/DialogTitle';



export class AccountDetails extends Component {

    constructor(props) {
        super(props);
        this.url = getURLBase(true) + "/totalbalance"

        this.state = {
            openDialog: false,
            isReady: false,
            isSweepReady: false,
            showSweepDetails: this.props.openSweep ? true : false,
            showAccountDetails: false,
            active: this.props.type,
        };
    }

    handleClickOpen = () => {
        this.setState({ openDialog: true })
    };

    handleClose = (value) => {
        this.setState({ openDialog: false })
    };

    componentDidMount() {
        if (!this.state.isReady)
            axios.post(this.url, { gid: this.props.gid }).then(
                (response) => {
                    var sweepAccount = response.data.body.categories.pop();
                    this.setState({ response: response.data.body, sweepAccount: sweepAccount })
                    this.setState({ isReady: true })
                }
            )

    }

    toggleSweepScreen = () => {
        var show = this.state.showSweepDetails;
        show = !show;
        this.setState({
            showSweepDetails: show
        }, () => {
            updateParentHeight("parent_TotalBalance", "child_SweepAccountDetails", this.state.showSweepDetails);
        });
    }

    toggleAccountDetails = () => {
        var show = this.state.showAccountDetails;
        show = !show;
        this.setState({ showAccountDetails: show },
            () => {
                updateParentHeight("parent_TotalBalance", "child_AccountDetails", this.state.showAccountDetails);
            });
    }

    render() {
        const InfoDialog = () => (
            <Dialog onClose={this.handleClose} open={this.state.openDialog}>

                <DialogTitle sx={{ fontSize: "1rem", display: "flex", alignItems: "flex-start", justifyContent: "space-between", margin: 0 }}>About Wyzr
                    <IconButton
                        aria-label="close"
                        onClick={this.handleClose}
                        sx={{
                            padding: 0,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseRoundedIcon />
                    </IconButton>
                </DialogTitle>
                <Divider light />
                <CardContent>
                    <Typography variant="body2" marginBottom={4} fontWeight={600}>
                        Wyzr Fintech Limited (‘Wyzr’) is registered in England & Wales with company number 12404769 with registered address at 201, The Water Gardens, London W2 2DF.
                    </Typography>

                    <Typography variant="body2" fontWeight={600}>
                        Wyzr Fintech Limited is the registered agent of Moneyhub Financial Technology Ltd (“Moneyhub”) who is authorised and regulated by the Financial Conduct Authority under the Payment Services Regulations 2017 (reg. no. 809360) for the provision of payment services. Head office Regus House, 1 Friary, Temple Way, Bristol, BS16EA. Email: support@moneyhub.co.uk.
                    </Typography>

                </CardContent>
            </Dialog>
        );





        return (
            <>
                <Card className="popup" id="child_AccountDetails">
                    <Box className="popupClose">
                        <IconButton aria-label="Close" onClick={this.props.toggleHandler}>
                            <ArrowBack />
                        </IconButton>
                    </Box>

                    <CardContent textAlign="center">
                        <Box className="popupHeader">
                            <Typography variant="h4" fontWeight={700} align="center" gutterBottom>{this.props.type} Balance</Typography>
                            <Typography variant="h2" fontSize="2rem" fontWeight={700} align="center" gutterBottom> {this.state.isReady ? `£ ${this.props.total}` : null}</Typography>
                        </Box>
                        {this.state.isReady ?
                            <Box className="popupBody" pt={{ xs: 12, sm: 0 }}>
                                {/* ##################################################################### */}
                                <Grid>
                                    <Paper variant="outlined" sx={{ borderColor: "white" }}>
                                        <Grid padding={2}>

                                            {this.state.response &&
                                                this.state.response.categories.map((transaction) => (
                                                    <TotalBalanceTransactionItem
                                                        type={this.props.type}
                                                        active={this.state.active}
                                                        changeActive={(newActive) => this.setState({ active: newActive })}
                                                        changeState={(state_obj) => this.setState(state_obj)}
                                                        toggleAccountDetails={this.toggleAccountDetails}
                                                        key={transaction.id}
                                                        transaction={transaction}
                                                        accounts={this.props.singleTypeAccounts}
                                                    />
                                                ))}


                                        </Grid>
                                        <Box textAlign="center">
                                            <Button variant="link" sx={{ marginTop: 4 }} onClick={this.handleClickOpen}>
                                                <Stack direction="row" justifyContent="center" alignItems="center" >
                                                    <Typography variant="body2" marginBottom={0}>
                                                        Powered by
                                                    </Typography>
                                                    <img src={moneyhubLogo} height={30} width="auto" alt="money hub" />
                                                </Stack>
                                            </Button>
                                        </Box>
                                    </Paper>
                                </Grid>

                                {updateHeightAfterContentUpdate("parent_TotalBalance", "child_AccountDetails", null, 2)}
                            </Box>
                            : <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "20vh" }}><CircularProgress color="success" /></Box>
                        }
                    </CardContent>
                </Card>

                <InfoDialog
                    open={this.state.openDialog}
                    onClose={this.handleClose}
                />
            </>
        );
    }
}

export default AccountDetails
